export default __webpack_public_path__ + "beabdbdcb1115b26a677cb20000fea76.svg";